// ภาษา TH/EN แบบเบา — เขียนข้อความไทยเป็น key แล้วแปลเป็นอังกฤษด้วย t("ข้อความไทย") ; ไม่มีใน dict = แสดงไทยตามเดิม
import { useCallback, useEffect, useState } from "react";

const KEY = "aitalk:lang";
const EVENT = "aitalk-lang-change";

const EN = {
  "ตัวละคร": "Characters", "จักรวาล": "Universes", "ครีเอเตอร์": "Creators", "จัดอันดับ": "Rankings", "ค้นหา": "Search",
  "สวัสดี": "Hello", "วันนี้อยากคุยกับใคร?": "Who do you want to talk to today?", "ค้นหาตัวละคร ครีเอเตอร์ หรือโค้ดแชร์": "Search characters, creators or share codes",
  "ใหม่ล่าสุด": "Newest", "กำลังมาแรง": "Trending", "ยอดนิยม": "Popular", "จากคนที่ติดตาม": "Following", "สำหรับคุณ": "For you",
  "ตัวละครทั้งหมด": "All characters", "ล้างตัวกรอง": "Clear filters", "ปัดตัวละคร": "Swipe", "ค้นหาด้วย AI": "AI search",
  "เริ่มแชท": "Start chat", "ไลก์": "Likes", "แชท": "Chats", "ข้อความ": "Messages", "ของขวัญ": "Gifts", "ติดตาม": "Follow", "กำลังติดตาม": "Following",
  "ข้อมูล": "About", "ความคิดเห็น": "Comments", "อันดับสายเปย์": "Top gifters", "คลิปสั้น": "Shorts", "โพสต์": "Posts", "แชร์": "Share", "รายงาน": "Report",
  "สร้างตัวละคร": "Create character", "สร้างจักรวาล": "Create universe", "ถัดไป": "Next", "ย้อนกลับ": "Back", "บันทึกร่าง": "Save draft", "เผยแพร่": "Publish",
  "ฟีดโซเชียล": "Social feed", "ครีเอเตอร์ฟีด": "Creators", "ส่วนตัว": "Private", "แจ้งเตือน": "Notifications", "อ่านทั้งหมด": "Mark all read", "ทั้งหมด": "All",
  "ตั้งค่า": "Settings", "ภาษา": "Language", "การแสดงผลแชท": "Chat display", "ออกจากระบบ": "Log out", "บันทึกการตั้งค่า": "Save settings",
  "โปรไฟล์ของฉัน": "My profile", "ตัวละครของฉัน": "My characters", "ร่าง": "Drafts", "รายการโปรด": "Favorites", "บันทึกไว้": "Saved", "แก้ไขโปรไฟล์": "Edit profile",
  "ผู้ติดตาม": "Followers", "วันนี้": "Today", "สัปดาห์นี้": "This week", "ไม่มีข้อมูล": "No data", "ผู้ดูแลระบบ": "Admin",
  "ปกติ": "Normal", "นวนิยาย": "Novel", "บล็อก": "Blog", "ขนาดตัวอักษร": "Font size", "ความโปร่งใสบอลลูน": "Bubble opacity",
};

export const getLang = () => (typeof localStorage !== "undefined" && localStorage.getItem(KEY)) || "th";
export const setLang = (lang) => {
  localStorage.setItem(KEY, lang);
  document.documentElement.lang = lang;
  window.dispatchEvent(new Event(EVENT));
};
if (typeof document !== "undefined") document.documentElement.lang = getLang();

/** hook: const { t, lang } = useI18n() */
export function useI18n() {
  const [lang, setL] = useState(getLang);
  useEffect(() => {
    const on = () => setL(getLang());
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  const t = useCallback((th) => (lang === "en" ? EN[th] || th : th), [lang]);
  return { t, lang };
}
